/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Current_SiteInputs */

const en_common_current_site = /** @type {(inputs: Common_Current_SiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current Site`)
};

const es_common_current_site = /** @type {(inputs: Common_Current_SiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sitio actual`)
};

/**
* | output |
* | --- |
* | "Current Site" |
*
* @param {Common_Current_SiteInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_current_site = /** @type {((inputs?: Common_Current_SiteInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Current_SiteInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_current_site(inputs)
	return en_common_current_site(inputs)
});